import { getNowPlaying, getRecentlyPlayed } from '../components/SpotifyAuth'

export default class CurrentListening {
	constructor(element) {

		this.block					= element;
		this.venue 					= element.dataset.venue;
		this.createRecentlyPlayed 	= this.createRecentlyPlayed.bind(this);
		this.getNowPlayingItem 		= this.getNowPlayingItem.bind(this);
		this.getRecentlyPlayedItem 	= this.getRecentlyPlayedItem.bind(this);
		this.nowPlaying				= this.getNowPlayingItem(this.venue)
		this.trackfields 			= document.querySelectorAll('[data-component="spotify-track-name"]');
		this.linkfields				= element.querySelectorAll('.pill--transparent');

		this.nowPlaying.then((nowPlayingItem) => {

			// console.log('now playing:' , nowPlayingItem)

			this.trackfields.forEach((field)=>{
				field.innerHTML = nowPlayingItem.artist + '&nbsp;&nbsp;&mdash;&nbsp;&nbsp;' + nowPlayingItem.title;
			})

			nowPlayingItem.songUrl && this.linkfields.forEach((link)=>{
				link.href = nowPlayingItem.songUrl;
			})

		})
		.then(() => {
			// Needs to start animation after text replaced because of safari rendering bug
			this.block.classList.add('b-current-listening--ready');
		})
		.catch(() => {
			// If now playing fails, try recently played instead
			this.createRecentlyPlayed()
		})

	}

	createRecentlyPlayed(){
		
		// console.log('no now playing. trying recently played')

		let recentlyPlayed = this.getRecentlyPlayedItem(this.venue)
		recentlyPlayed.then((recentlyPlayedItem)=>{

			// console.log( 'recently played:', recentlyPlayedItem.data )

			const url			= recentlyPlayedItem.data.items[0].track.external_urls.spotify
			const artist 		= recentlyPlayedItem.data.items[0].track.artists[0].name
			const trackTitle 	= recentlyPlayedItem.data.items[0].track.name

			this.trackfields.forEach((field)=>{
				field.innerHTML = artist + '&nbsp;&nbsp;&mdash;&nbsp;&nbsp;' + trackTitle;
			})

			url && this.linkfields.forEach((link)=>{
				link.href = url;
			})
		
		})
		.then(() => {
			// Needs to start animation after text replaced because of safari rendering bug
			this.block.classList.add('b-current-listening--ready');
		}).catch(() => {
			// If all fails, hide from users
			this.block.remove();
		})
	}

	async getNowPlayingItem(
		client_id,
		client_secret,
		refresh_token,
		venue
	) {
		const response = await getNowPlaying(client_id, client_secret, refresh_token, venue);
		
		// if (response.status === 204 || response.status > 400) {
		// 	return false;
		// }

		const song = await response.json();
		const albumImageUrl = song.item.album.images[0].url;
		const artist = song.item.artists.map((_artist) => _artist.name).join(", ");
		const isPlaying = song.is_playing;
		const songUrl = song.item.external_urls.spotify;
		const title = song.item.name;
		
		return {
			albumImageUrl,
			artist,
			isPlaying,
			songUrl,
			title,
		};
	}

	async getRecentlyPlayedItem(
		client_id,
		client_secret,
		refresh_token,
		venue
	) {
		const response = await getRecentlyPlayed(client_id, client_secret, refresh_token, venue);		
		const data = await response.json();
		const items = data.items;
		
		return {
			data
		};
	}

}